import {
  REQUEST_BROKERCASEHEADER, RECEIVE_BROKERCASEHEADER, ERROR_BROKERCASEHEADER,
  REQUEST_BROKERHISTORY, RECEIVE_BROKERHISTORY, ERROR_BROKERHISTORY,
  REQUEST_BROKERWAIVER_DECISION, RECEIVE_BROKERWAIVER_DECISION, ERROR_BROKERWAIVER_DECISION,
  REQUEST_BROKERWAIVER_DECISION_POST, RECEIVE_BROKERWAIVER_DECISION_POST, ERROR_BROKERWAIVER_DECISION_POST,
} from 'typeConstants';

import { broker as initialState } from '../initialState.tsx';

const broker = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BROKERCASEHEADER:
      return {
        ...state,
        fetchingBrokerCaseHeader: true
      };
    case RECEIVE_BROKERCASEHEADER:
      return {
        ...state,
        brokerCaseHeader: action.payload,
        fetchingBrokerCaseHeader: false
      };
    case ERROR_BROKERCASEHEADER:
      return {
        ...state,
        fetchingBrokerCaseHeader: false
      };

    case REQUEST_BROKERHISTORY:
      return {
        ...state,
        fetchingBrokerCaseHistory: true
      };
    case RECEIVE_BROKERHISTORY:
      return {
        ...state,
        brokerCaseHistory: action.payload,
        fetchingBrokerCaseHistory: false
      };
    case ERROR_BROKERHISTORY:
      return {
        ...state,
        fetchingBrokerCaseHistory: false
      };

    case REQUEST_BROKERWAIVER_DECISION:
      return {
        ...state,
        fetchingWaiverDetails: true
      };
    case RECEIVE_BROKERWAIVER_DECISION:
      return {
        ...state,
        waiverDetails: action.payload,
        fetchingWaiverDetails: false
      };
    case ERROR_BROKERWAIVER_DECISION:
      return {
        ...state,
        fetchingWaiverDetails: false
      };

    case REQUEST_BROKERWAIVER_DECISION_POST:
      return {
        ...state,
        fetchingWaiverDetails: true
      };
    case RECEIVE_BROKERWAIVER_DECISION_POST:
      return {
        ...state,
        waiverDetails: action.payload,
        fetchingWaiverDetails: false
      };
    case ERROR_BROKERWAIVER_DECISION_POST:
      return {
        ...state,
        fetchingWaiverDetails: false
      };

    default:
      return state;
  }
};

export default broker;
